export default {
  name: "FilterSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M4 10a4.99 4.99 0 0 1 9.74-1.5H26.5a1.5 1.5 0 1 1 0 3H13.74A4.99 4.99 0 0 1 4 10zm19 7a4.99 4.99 0 0 0-4.74 3.5H5.5a1.5 1.5 0 1 0 0 3h12.76A4.99 4.99 0 0 0 28 22a5 5 0 0 0-5-5z",
  },
}
